module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/iJ4QGM/tc-custom/9781481416160.jpg?1730492842147",
      "alt": "This image is the cover for the book Anna, Banana, and the Puppy Parade"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Anna, Banana, and the Puppy Parade\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Anna enters her beloved dog Banana in a contest in the fourth book of this “fast-paced, fun, and funny” (Megan McDonald, bestselling author of the Judy Moody series) illustrated chapter book series about the joys and challenges of elementary school friendships.")]), _c('br'), _c('br'), _vm._v("Anna can’t wait for the Puppy Parade. She’s certain Banana will win. Soon Banana will be famous—and that means Anna will be famous, too!"), _c('br'), _c('br'), _vm._v("But when Sadie and Isabel suggest they all enter the parade together, Anna starts feeling a little unsure about sharing her dog—and the spotlight—with her friends."), _c('br'), _c('br'), _vm._v("How can Anna be Best in Show "), _c('i', [_vm._v("and")]), _vm._v(" a good best friend?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anica Mrose Rissi, Meg Park\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Anica Mrose Rissi grew up on an island off the coast of Maine, where she read a lot of books and loved a lot of pets. She now tells and collects stories, makes up songs on her violin, and eats lots of cheese with her friends in Princeton, New Jersey, where she lives with her dog, Arugula. Find out more at AnicaRissi.com and follow @AnicaRissi on Twitter.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    S&S Books for Young Readers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0